import Helper from '@ember/component/helper';

type Positional = [string];

export interface MatchMediaSignature {
  Args: {
    Positional: Positional;
  };
  Return: boolean;
}

/** Reactively matches a CSS media-query string against the current viewport. */
export default class MatchMedia extends Helper<MatchMediaSignature> {
  mediaQueryList: MediaQueryList | null = null;
  onChangeHandler: ((event: MediaQueryListEvent) => void) | null = null;

  compute([mediaQueryString]: Positional) {
    return this.addMatchMediaListener(mediaQueryString);
  }

  willDestroy() {
    this.removeMatchMediaListener();
  }

  addMatchMediaListener(mediaQueryString: string) {
    this.removeMatchMediaListener();

    this.onChangeHandler = (event: MediaQueryListEvent) => {
      // @ts-expect-error: event is not assignable to type MediaQueryListEvent
      this.recompute(event.matches);
    };

    this.mediaQueryList = window.matchMedia(mediaQueryString);

    this.mediaQueryList.addEventListener('change', this.onChangeHandler);

    return this.mediaQueryList.matches;
  }

  removeMatchMediaListener() {
    if (this.onChangeHandler) {
      this.mediaQueryList?.removeEventListener('change', this.onChangeHandler);
      this.mediaQueryList = null;
      this.onChangeHandler = null;
    }
  }
}
